import React from "react";
import { useEffect, useState } from "react";
import axios from "axios";
import { Link } from "react-router-dom";

export default function Conversations({ conversation, currnetUser }) {
  const PS = process.env.REACT_APP_PUBLIC_SERVER;
  const PF = process.env.REACT_APP_PUBLIC_FOLDER;

  const [user, setUser] = useState([]);
  useEffect(() => {
    const amigoId = conversation.members.find((m) => m !== currnetUser._id);

    const getUser = async () => {
      try {
        const res = await axios("usuarios?userId=" + amigoId);
        setUser(res.data);
      } catch (err) {
        console.log(err);
      }
    };
    getUser();
  }, [currnetUser, conversation]);

  return (
    <>
      <a className="text-body">
        <div className="d-flex align-items-start mt-1 p-2">
          <img
            src={
              user.imagemProfil ? user.imagemProfil : PS + "users/noavatar.jpg"
            }
            className="me-2 rounded-circle"
            height="48"
            alt="Ricky J"
          />
          <div className="w-100 overflow-hidden">
            <h5 className="mt-0 mb-0 font-14">
              <span className="float-end text-muted font-12">Mon</span>
              {user.username}
            </h5>
            <p className="mt-1 mb-0 text-muted font-14">
              <span className="w-25 float-end text-end">
                <span className="badge badge-danger-lighten">28</span>
              </span>
              <span className="w-75">hey</span>
            </p>
          </div>
        </div>
      </a>
    </>
  );
}
